export default __webpack_public_path__ + "static/media/searchicon.da79bd25.svg";